var model = {
    'chevrolet': [
        {'niceName': 'Spark', 'id': 'spark-fuel-efficient-car'},
        {'niceName': 'Spark EV', 'id': 'spark-fuel-efficient-car'},
        {'niceName': 'Sonic', 'id': 'sonic-small-car'},
        {'niceName': 'Cruze', 'id': 'cruze-compact-car'},
        {'niceName': 'Cruze Limited', 'id': 'cruze-compact-car'},
        {'niceName': 'Colorado', 'id': 'colorado-mid-size-truck'},
        {'niceName': 'Trax', 'id': 'trax-small-suv'},
        {'niceName': 'Malibu', 'id': 'malibu-mid-size-car'},
        {'niceName': 'City Express', 'id': 'city-express-small-cargo-van'},
        {'niceName': 'Malibu Limited', 'id': 'malibu-limited'},
        {'niceName': 'Equinox', 'id': 'equinox-fuel-efficient-suv'},
        {'niceName': 'Camaro', 'id': 'camaro-sports-car'},
        {'niceName': 'Camaro ZL1', 'id': 'camaro-zl1'},
        {'niceName': 'Impala', 'id': 'impala-full-size-cars'},
        {'niceName': 'Silverado 1500HD', 'id': 'silverado-1500-pickup-truck'},
        {'niceName': 'Silverado 2500HD', 'id': 'silverado-2500hd-heavy-duty-trucks'},
        {'niceName': 'Silverado 3500HD', 'id': 'silverado-3500hd-diesel-trucks'},
        {'niceName': 'Traverse', 'id': 'traverse-mid-size-suv'},
        {'niceName': 'Express Cargo', 'id': 'express/cargo'},
        {'niceName': 'Express Passenger', 'id': 'express/passenger'},
        {'niceName': 'Volt', 'id': 'volt-electric-car'},
        {'niceName': 'SS', 'id': 'ss-sports-sedan'},
        {'niceName': 'Tahoe', 'id': 'tahoe-full-size-suv'},
        {'niceName': 'Suburban', 'id': 'suburban-suv'},
        {'niceName': 'Corvette Stingray', 'id': 'corvette-stingray'},
        {'niceName': 'Corvette Grand Sport', 'id': 'corvette-grand-sport'},
        {'niceName': 'Corvette Z06', 'id': 'corvette-z06-supercar'}
    ],
    'maserati': [
        {'niceName': 'GHIBLI',                 'trim': 'Base',          'id': 'GHIBLI_350'},
        {'niceName': 'GHIBLI',                 'trim': 'S',             'id': 'GHIBLI_410'},
        {'niceName': 'GHIBLI',                 'trim': 'S Q4',          'id': 'GHIBLI_410A'},
        {'niceName': 'LEVANTE',                'trim': 'Base',          'id': 'LV_350A'},
        {'niceName': 'LEVANTE',                'trim': 'S',             'id': 'LV_430A'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S',             'id': 'QPV6_410R'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S GranLusso',   'id': 'QPV6_410R'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S Q4',          'id': 'QPV6_410A'},
        {'niceName': 'QUATTROPORTE',           'trim': 'GTS',           'id': 'QPV8_530'},
        {'niceName': 'GRANTURISMO',            'trim': 'Sport',         'id': 'GTSPauto'},
        {'niceName': 'GRANTURISMO',            'trim': 'MC',            'id': 'GTMC'},
        {'niceName': 'GRANTURISMO',            'trim': 'MC Centennial', 'id': 'GTMC100'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'Base',          'id': 'GC'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'Sport',         'id': 'GCS'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'MC',            'id': 'GCMC'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'MC Centennial', 'id': 'GCMC100'}
    ],
    'nissan': [
        { 'niceName': 'VERSA',               'submodel': 'sedan',        'id':'VSD' },
        { 'niceName': 'VERSA',               'submodel': 'note',        'id':'VER' },
        { 'niceName': 'VERSA NOTE',          'submodel': 'hatchback',        'id':'VER' },
        { 'niceName': 'SENTRA',              'submodel': 'sedan',        'id':'SEN' },
        { 'niceName': 'ALTIMA',              'submodel': 'sedan',               'id':'ALT' },
        { 'niceName': 'MAXIMA',              'submodel': 'sedan',        'id':'MAX' },
        { 'niceName': '370Z',                'submodel': 'coupe',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'nismo',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'nismo-tech',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'convertible',        'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'roadster',        'id':'ZRD' },
        { 'niceName': 'GT-R',                'submodel': 'coupe',        'id':'GTR' },
        { 'niceName': 'GT-R',                'submodel': 'nismo',        'id':'GTR' },
        { 'niceName': 'JUKE',                'submodel': 'hatchback',        'id':'JKE' },
        { 'niceName': 'JUKE',                'submodel': 'nismo-rs',        'id':'JKE' },
        { 'niceName': 'LEAF',                'submodel': 'hatchback',        'id':'LEF' },
        { 'niceName': 'ROGUE',               'submodel': 'suv',        'id':'RGE' },
        { 'niceName': 'ROGUE SELECT',        'submodel': 'suv',        'id':'RGE' },
        { 'niceName': 'MURANO',              'submodel': 'hybrid',        'id':'MUR' },
        { 'niceName': 'MURANO',              'submodel': 'suv',        'id':'MUR' },
        { 'niceName': 'PATHFINDER',          'submodel': 'suv',        'id':'PTH' },
        { 'niceName': 'ARMADA',              'submodel': 'suv',     'id':'ARM' },
        { 'niceName': 'QUEST',               'submodel': 'minivan',        'id':'QST' },
        { 'niceName': 'NV PASSENGER',        'submodel': 'van',        'id':'NV Passenger' },
        { 'niceName': 'FRONTIER',            'submodel': 'crew-cab',        'id':'' },
        { 'niceName': 'FRONTIER',            'submodel': 'king-cab',        'id':'720' },
        { 'niceName': 'TITAN',               'submodel': 'crew-cab',        'id':'TTN' },
        { 'niceName': 'TITAN',               'submodel': 'regular-cab',        'id':'TTN' },
        { 'niceName': 'TITAN XD',            'submodel': 'crew-cab',        'id':'TXD' },
        { 'niceName': 'TITAN XD',            'submodel': 'diesel',        'id':'TXD' },
        { 'niceName': 'TITAN XD',            'submodel': 'regular-cab',        'id':'TXD' },
        { 'niceName': 'NV200 COMPACT CARGO', 'submodel': '',        'id':'NV200' },
        { 'niceName': 'NV200',               'submodel': 'minivan',        'id':'NV200' },
        { 'niceName': 'NV CARGO',            'submodel': 'van',        'id':'NV1500' },
        { 'niceName': 'NV200 TAXI',          'submodel': '',        'id':'nv200-taxi' }
    ]
};

module.exports = {
    model: model
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-models.js
// module id = 148
// module chunks = 0 1 23